/* CraftPK - product gallery, hover zoom and lightbox. 2026-10-19 */
(function () {
var root = document.querySelector('[data-cp-pdp]');
if (!root) return;
var q = function (s, c) { return (c || root).querySelector(s); };
var qa = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };
var fine = window.matchMedia && window.matchMedia('(hover:hover) and (pointer:fine)').matches;
/* ---------- Gallery ---------- */
var track = q('[data-cp-track]');
var slides = qa('[data-cp-slide]');
var thumbs = qa('[data-cp-thumb]');
var dots = qa('.cp-gal__dots i');
var curEl = q('[data-cp-cur]');
var prev = q('[data-cp-prev]'), next = q('[data-cp-next]');
var cur = 0, ticking = false;
function setActive(i) {
cur = i;
thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
if (curEl) curEl.textContent = i + 1;
if (prev) prev.disabled = i === 0;
if (next) next.disabled = i === slides.length - 1;
slides.forEach(function (s, k) {
if (k !== i) { var v = s.querySelector('video'); if (v && !v.paused) v.pause(); }
});
var t = thumbs[i];
if (t) {
var box = t.parentNode;
if (box.scrollHeight > box.clientHeight + 2) box.scrollTo({ top: t.offsetTop - box.clientHeight / 2 + t.offsetHeight / 2, behavior: 'smooth' });
else if (box.scrollWidth > box.clientWidth + 2) box.scrollTo({ left: t.offsetLeft - box.clientWidth / 2 + t.offsetWidth / 2, behavior: 'smooth' });
}
}
function go(i, instant) {
if (!track || !slides.length) return;
i = Math.max(0, Math.min(slides.length - 1, i));
track.scrollTo({ left: i * track.clientWidth, behavior: instant ? 'auto' : 'smooth' });
setActive(i);
}
if (track && slides.length) {
track.addEventListener('scroll', function () {
if (ticking) return;
ticking = true;
requestAnimationFrame(function () {
ticking = false;
var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
if (i !== cur && i >= 0 && i < slides.length) setActive(i);
});
}, { passive: true });
track.addEventListener('keydown', function (e) {
if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1); }
if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1); }
});
window.addEventListener('resize', function () { go(cur, true); });
thumbs.forEach(function (t) {
t.addEventListener('click', function () { go(parseInt(t.getAttribute('data-cp-thumb'), 10)); });
if (fine) t.addEventListener('mouseenter', function () { go(parseInt(t.getAttribute('data-cp-thumb'), 10)); });
});
if (prev) prev.addEventListener('click', function () { go(cur - 1); });
if (next) next.addEventListener('click', function () { go(cur + 1); });
setActive(0);
}
/* Hover zoom (mouse only) */
if (fine) {
qa('[data-cp-zoom]').forEach(function (z) {
var lens;
z.addEventListener('mouseenter', function () {
if (!lens) {
lens = document.createElement('div');
lens.className = 'cp-gal__lens';
lens.style.backgroundImage = 'url("' + z.getAttribute('data-cp-zoom') + '")';
z.appendChild(lens);
}
z.classList.add('is-zoom');
});
z.addEventListener('mousemove', function (e) {
if (!lens) return;
var r = z.getBoundingClientRect();
lens.style.backgroundPosition = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
});
z.addEventListener('mouseleave', function () { z.classList.remove('is-zoom'); });
});
}
/* ---------- Lightbox ---------- */
var lb = q('[data-cp-lb]');
var lbTrack = lb && q('[data-cp-lb-track]', lb);
var lbSlides = lb ? qa('.cp-lb__slide', lb) : [];
var lbCur = lb && q('[data-cp-lb-cur]', lb);
var lbIndex = 0, lastFocus = null;
function lbLoad(i) {
[i - 1, i, i + 1].forEach(function (k) {
var s = lbSlides[k]; if (!s) return;
var img = s.querySelector('img[data-src]');
if (img) { img.src = img.getAttribute('data-src'); img.removeAttribute('data-src'); }
});
}
function lbSet(i) {
lbIndex = i; lbLoad(i);
if (lbCur) lbCur.textContent = i + 1;
}
function lbGo(i) {
if (!lbTrack) return;
i = Math.max(0, Math.min(lbSlides.length - 1, i));
lb.classList.remove('is-zoomed');
lbTrack.scrollTo({ left: i * lbTrack.clientWidth, behavior: 'smooth' });
lbSet(i);
}
function lbOpen(i) {
if (!lb) return;
lastFocus = document.activeElement;
lb.hidden = false;
document.documentElement.classList.add('cp-lb-open');
lbSet(i);
requestAnimationFrame(function () { lbTrack.scrollLeft = i * lbTrack.clientWidth; });
var c = q('[data-cp-lb-close]', lb); if (c) c.focus();
}
function lbClose() {
if (!lb || lb.hidden) return;
lb.hidden = true;
lb.classList.remove('is-zoomed');
document.documentElement.classList.remove('cp-lb-open');
if (lastFocus && lastFocus.focus) lastFocus.focus();
}
function currentLbIndex() {
var s = slides[cur];
var z = s && s.querySelector('[data-cp-lb-index]');
return z ? parseInt(z.getAttribute('data-cp-lb-index'), 10) : 0;
}
if (lb) {
qa('[data-cp-zoom]').forEach(function (z) {
z.addEventListener('click', function () { lbOpen(parseInt(z.getAttribute('data-cp-lb-index'), 10) || 0); });
});
var openBtn = q('[data-cp-open]');
if (openBtn) openBtn.addEventListener('click', function () { lbOpen(currentLbIndex()); });
q('[data-cp-lb-close]', lb).addEventListener('click', lbClose);
var lp = q('[data-cp-lb-prev]', lb), ln = q('[data-cp-lb-next]', lb);
if (lp) lp.addEventListener('click', function () { lbGo(lbIndex - 1); });
if (ln) ln.addEventListener('click', function () { lbGo(lbIndex + 1); });
var lbTick = false;
lbTrack.addEventListener('scroll', function () {
if (lbTick) return; lbTick = true;
requestAnimationFrame(function () {
lbTick = false;
var i = Math.round(lbTrack.scrollLeft / Math.max(1, lbTrack.clientWidth));
if (i !== lbIndex && i >= 0 && i < lbSlides.length) { lb.classList.remove('is-zoomed'); lbSet(i); }
});
}, { passive: true });
lbSlides.forEach(function (s) {
var img = s.querySelector('img');
img.addEventListener('click', function (e) {
var r = img.getBoundingClientRect();
img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
lb.classList.toggle('is-zoomed');
});
img.addEventListener('mousemove', function (e) {
if (!lb.classList.contains('is-zoomed')) return;
var r = s.getBoundingClientRect();
img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
});
});
lb.addEventListener('click', function (e) { if (e.target.classList.contains('cp-lb__slide')) lbClose(); });
document.addEventListener('keydown', function (e) {
if (lb.hidden) return;
if (e.key === 'Escape') lbClose();
if (e.key === 'ArrowRight') lbGo(lbIndex + 1);
if (e.key === 'ArrowLeft') lbGo(lbIndex - 1);
});
}
window.cpGallery = {
goMedia: function (id) { slides.forEach(function (s, k) { if (s.getAttribute('data-media-id') === String(id)) go(k); }); }
};
})();